export var defaultIntputProps = {
    type: 'text'
};
